import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditProduct = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Product'
      fields={fields}
      apiPath={`admin/products/${props.params.productId}`}
      successRedirectPath='/ecommerce/products'
      buildMenuItems={menuItems}
    />
  )
}

export default EditProduct
